import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export function RegistrationSuccessModal({
  open,
  onDismiss,
  translationKeyPrefix = 'registration.menu.modal.success',
}) {
  const { t } = useTranslation(['onboarding', 'button']);

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            maxWidth: 400,
            width: '100%',
            position: 'relative',
          },
        },
      }}
    >
      <IconButton
        type="button"
        aria-label={t('close', { ns: 'button' })}
        onClick={() => onDismiss?.()}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
          color: 'text.secondary',
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent
        sx={{
          textAlign: 'center',
          py: 4,
          px: 3,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 56, color: 'grey.500', mb: 2 }}
          />

          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{ fontSize: 22, width: '100%' }}
          >
            {t(`${translationKeyPrefix}.title`)}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 2,
              color: 'text.primary',
              lineHeight: 1.6,
              width: '100%',
            }}
          >
            <Trans
              i18nKey={`${translationKeyPrefix}.line1`}
              ns="onboarding"
              components={{
                0: <Box component="span" sx={{ fontWeight: 700 }} />,
                bold: <Box component="span" sx={{ fontWeight: 700 }} />,
              }}
            />
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              lineHeight: 1.6,
              width: '100%',
            }}
          >
            <Trans
              i18nKey={`${translationKeyPrefix}.line2`}
              ns="onboarding"
              components={{
                0: <Box component="span" sx={{ fontWeight: 700 }} />,
                bold: <Box component="span" sx={{ fontWeight: 700 }} />,
              }}
            />
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
